__turbopack_context__.v({
  "item-container": "mochi-refueling-tutorial-vertical-list-module-scss-module__zDDq2a__item-container",
  "item-content": "mochi-refueling-tutorial-vertical-list-module-scss-module__zDDq2a__item-content",
  "list": "mochi-refueling-tutorial-vertical-list-module-scss-module__zDDq2a__list",
});
